import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from 'semantic-ui-react';
import CheckboxField from '../../../formFields/checkboxField';
import StandardFieldLabel from '../../../formFields/formFieldWrapper/standardFieldLabel';
import { useBreakpoints } from '../../../../hooks';
const Boolean = ({ definition, value, elmId, onChange, }) => {
    const breakpoint = useBreakpoints();
    const isMobile = breakpoint === 'mobile';
    const label = definition.label;
    return (_jsx(Form, { style: { marginTop: 6 }, children: _jsx(CheckboxField, { compact: isMobile, label: _jsx(StandardFieldLabel, { elmId: `${elmId}_${definition.name}_label`, label: definition.label, subLabel: definition.description || '' }), elmId: `${elmId}_${definition.name}`, name: definition.name, value: definition.name, role: 'info', checked: value, onChange: (e, data) => {
                onChange(definition.name, data.checked);
            } }, label) }));
};
export default Boolean;
//# sourceMappingURL=boolean.js.map